// #417 — shared event-name constants for the state-selector contract.
//
// Every state-selector implementation (Vue: state-selector.js,
// state-selector quickshop binding via x-template-state-selector.liquid;
// vanilla: state-selector-menu.js) and every listener (PDP zone list,
// PLP badges, quickshop sidebar, cart auto-removal, geo bootstrap)
// imports from here so a rename propagates instead of silently drifting.
//
// Payload shapes:
//   SELECT    detail: { state: AU_STATE_CODE }            — UI -> system
//   SELECTED  detail: { state: AU_STATE_CODE }            — system -> UI
//   DETECTED  detail: { state: AU_STATE_CODE, confidence: 'HIGH'|'MEDIUM' }
//   CLEARED   no detail

export const STATE_EVENTS = Object.freeze({
  SELECT: 'tena:select-state',
  SELECTED: 'tena:state-selected',
  DETECTED: 'tena:state-detected',
  CLEARED: 'tena:state-cleared',
});
